<template>
  <BootstrapModal :show="showModal"
                  :title="this.altarServer != null ? 'Messdiener:in bearbeiten' : 'Neue:n Messdiener:in anlegen'"
                  :trigger-class=triggerClass :trigger-icon=triggerIcon
                  :trigger-text="triggerText" submit-btn="Speichern" @close="handleClose" @open="handleOpen"
                  @save="handleSave">
    <template v-slot:body>
      <form class="row row-cols-3 g-3">
        <div class="col">
          <label class="form-label" for="firstname">Vorname</label>
          <input id="firstname" v-model="this.altarServer.firstname" class="form-control"
                 placeholder="Vorname" required type="text">
        </div>
        <div class="col">
          <label class="form-label" for="lastname">Nachname</label>
          <input id="lastname" v-model="this.altarServer.lastname" class="form-control"
                 placeholder="Nachname" required type="text">
        </div>
        <div class="col">
          <label class="form-label" for="planname">Planname</label>
          <input id="planname" v-model="this.altarServer.planname" class="form-control"
                 placeholder="Planname" required type="text">
        </div>
        <div class="col">
          <label class="form-label">E-Mail-Adressen</label>
          <div v-for="(email, i) in this.altarServer.emails" :key="i" class="input-group mb-1">
            <input v-model="this.altarServer.emails[i]" class="form-control" placeholder="E-Mail" type="email">
            <button class="btn btn-outline-danger" type="button" @click="removeEmail(i)">
              <em class="align-middle material-icons">delete</em>
            </button>
          </div>
          <button class="btn btn-outline-secondary btn-sm" type="button" @click="addEmail">
            <em class="align-middle material-icons">add</em> Adresse
          </button>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="altarServer">Messdiener?</label>
            <input id="altarServer" v-model="this.altarServer.altarServer" class="form-check-input"
                   type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="active">Aktiv?</label>
            <input id="active" v-model="this.altarServer.active" class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="leader">Leiter?</label>
            <input id="leader" v-model="this.altarServer.leader" class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="incense">Weihrauch?</label>
            <input id="incense" v-model="this.altarServer.incense" class="form-check-input"
                   type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="saturday">Samstags dienen?</label>
            <input id="saturday" v-model="this.altarServer.saturday" class="form-check-input"
                   type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="sunday">Sonntags dienen?</label>
            <input id="sunday" v-model="this.altarServer.sunday" class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="evenCalendarWeeks">Gerade KWs dienen?</label>
            <input id="evenCalendarWeeks" v-model="this.altarServer.evenCalendarWeeks"
                   class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="oddCalendarWeeks">Ungerade KWs dienen?</label>
            <input id="oddCalendarWeeks" v-model="this.altarServer.oddCalendarWeeks"
                   class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="toleratesIncense">Verträgt Weihrauch?</label>
            <input id="toleratesIncense" v-model="this.altarServer.toleratesIncense" class="form-check-input"
                   type="checkbox">
          </div>
        </div>
        <div class="col">
          <label class="form-label" for="partners">Partner</label>
          <multiselect id="partners" v-model="this.altarServer.partners"
                       :custom-label="this.altarServerStore.getPlannameById"
                       :multiple="true" :options="this.altarServerStore.getIDs"></multiselect>
        </div>
        <div class="col">
          <label class="form-label" for="notPartners">Nicht-Partner</label>
          <multiselect id="notPartners" v-model="this.altarServer.notPartners"
                       :custom-label="this.altarServerStore.getPlannameById" :multiple="true"
                       :options="this.altarServerStore.getIDs"></multiselect>
        </div>
      </form>
    </template>
  </BootstrapModal>
</template>

<script>
import BootstrapModal from "@/components/BootstrapModal";
import Multiselect from "vue-multiselect";
import {useAltarServerStore} from "@/stores/altarServer";

export default {
  name: "AltarServerCreateEditModal",
  props: ['passInAltarServer', 'triggerIcon', 'triggerText', 'triggerClass'],
  data: function () {
    return {
      altarServer: {},
      showModal: false
    }
  },
  methods: {
    handleOpen() {
      this.showModal = true;
      this.altarServer = this.passInAltarServer == null ? {} : this.passInAltarServer;
      if (!Array.isArray(this.altarServer.emails))
        this.altarServer.emails = [];
    },
    addEmail() {
      this.altarServer.emails.push('');
    },
    removeEmail(i) {
      this.altarServer.emails.splice(i, 1);
    },
    handleClose() {
      this.showModal = false;
      this.altarServer = {};
    },
    handleSave() {
      if (Array.isArray(this.altarServer.emails))
        this.altarServer.emails = this.altarServer.emails.filter(e => e.trim() !== '');
      if (this.altarServer.id == null)
        this.altarServerStore.addItem(this.altarServer);
      else
        this.altarServerStore.updateItem(this.altarServer);
      this.handleClose();
    },
  },
  components: {
    BootstrapModal,
    Multiselect
  },
  created() {
    if (!this.altarServerStore.loadedData)
      this.altarServerStore.getData();
  },
  setup() {
    const altarServerStore = useAltarServerStore();
    return {altarServerStore};
  }
}
</script>
